import { MdSchedule } from "react-icons/md";
import { getPercent } from "../../../../utils/getPercent";
import { useContext } from "react";
import CustomSkelton from "../../../../Components/Skeletons/CustomSkelton";
import StatusCard from "../StatusCard/StatusCard";
import { dashboardContext } from "../../Dashboard";

export default function ScheduleStatus() {

    const { data, isLoading } = useContext(dashboardContext);

    const future = data?.FuturecheduleCount || 0;
    const inprogress = data?.inprogressScheduleCount || 0;
    const inactive = data?.InactivescheduleCount || 0;
    const completed = data?.completedSchedulecount || 0;
    const cancelled = data?.cancelledschedule || 0;

    const total = data?.activescheduleCount || 0;

    const futurePercent = getPercent(future, total);
    const inprogressPercent = getPercent(inprogress, total);
    const inactivePercent = getPercent(inactive, total);
    const completedPercent = getPercent(completed, total);
    const cancelledPercent = getPercent(cancelled, total);


    return (
        <>
            {isLoading ? (
                <CustomSkelton variant="rectangular" height={320} />
            ) : (
                <StatusCard
                    uniqueKey="schedules"
                    title="Schedules"
                    // data={[allPercent, newPercent, progressPercent, futurePercent]}
                    // labels={['All', 'New', 'In Progress', 'Future']}
                    // colors={['#3498DB', '#1DB954', '#F1C40F', '#9B59B6']}

                    data={[inprogress, future, inactive, completed, cancelled]}
                    labels={['In Progress', 'Future', 'Inactive', 'Completed', 'Cancelled']}
                    colors={['#F1C40F', '#3498DB', '#7C96AB', '#1DB954', '#E74C3C']}
                    icon={<MdSchedule />}
                    total={total}
                    chartType="donut"
                >
                    <div className='dashboard-status-container'>
                        {/* <span className="dashboard-status-label">
                            <span className="status-dot" style={{ color: '#3498DB' }}>●</span>
                            All Schedules {all} ({allPercent}%)
                        </span> */}

                        <span className="dashboard-status-label">
                            <span className="status-dot" style={{ color: '#F1C40F' }}>●</span>
                            In Progress {inprogress} ({inprogressPercent}%)
                        </span>

                        <span className="dashboard-status-label">
                            <span className="status-dot" style={{ color: '#3498DB' }}>●</span>
                            {/* <span className="status-dot" style={{ color: '#1DB954' }}>●</span> */}
                            Future {future} ({futurePercent}%)
                        </span>
                        <span className="dashboard-status-label">
                            <span className="status-dot" style={{ color: '#7C96AB' }}>●</span>
                            Inactive {inactive} ({inactivePercent}%)
                        </span>
                        <span className="dashboard-status-label">
                            <span className="status-dot" style={{ color: '#1DB954' }}>●</span>
                            Completed {completed} ({completedPercent}%)
                        </span>
                        <span className="dashboard-status-label">
                            <span className="status-dot" style={{ color: '#E74C3C' }}>●</span>
                            Cancelled {cancelled} ({cancelledPercent}%)
                        </span>
                    </div>
                </StatusCard>
            )}
        </>
    );
}
